import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DashboardTile } from '../../../dashboard/models/dashboard-tile.model';
import { DefaultTileComponentAccessor, Tiles } from './tile-component-accessor';

@Component({
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-tile-wrapper',
    templateUrl: './tile-wrapper.component.html',
    host: {
        class: 'tile-wrapper',
    },
    standalone: false
})
export class TileWrapperComponent {
   @Input('tileConfig') tileConfig: DashboardTile;

   @Input('isFullscreen') isFullscreen: boolean = false;

   @Input('isEditing') isEditing: boolean = false;

   @Input('showHeader') showHeader: boolean = true;

   @Input('isPreview') isPreview: boolean = false;

   tiles = Tiles;

   componentAccessor = DefaultTileComponentAccessor;
}
